'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';

class OAuthHandler extends Component {
  constructor(props) {
    super(props);
    this.handleOAuthResponse = this.handleOAuthResponse.bind(this);
  }

  componentDidMount() {
    window.addEventListener('message', this.handleOAuthResponse);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleOAuthResponse);
  }

  handleOAuthResponse(evt) {
    if (evt.data && typeof evt.data === 'string' && evt.data[0] === '{') {
      try {
        const parsedResponse = JSON.parse(evt.data);
        const {
          data
        } = parsedResponse;

        if (data.connected) {
          this.props.onSuccess(data);
        } else {
          this.props.onFailure(data);
        }
      } catch (error) {// We will always pass 'data' into the postMessage body, for both oauth successes
        // and failures, so any errors that occur here are due to other postMessage calls
        // from other libraries, such as the notification heartbeat calls.
        //
        // See settings-ui#1196 for similar issue on the Shopify side.
        // TLDR: we can safely ignore these.
      }
    }
  }

  render() {
    return null;
  }

}

OAuthHandler.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired
};
export default OAuthHandler;